module.exports = __webpack_public_path__ + "img/ironhorse.1a4ce656.jpg";